
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Component_79_2","data-name":"Component 79 – 2","xmlns":"http://www.w3.org/2000/svg","width":"35","height":"35"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Rectangle_7517","data-name":"Rectangle 7517","fill":"#fff","stroke":"#e4e8f2","stroke-width":"1"}},[_c('rect',{attrs:{"width":"35","height":"35","rx":"8","stroke":"none"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"34","height":"34","rx":"7.5","fill":"none"}})]),_c('g',{attrs:{"id":"Group_1074","data-name":"Group 1074","transform":"translate(8.5 4.5)"}},[_c('g',{attrs:{"id":"Group_1072","data-name":"Group 1072","transform":"translate(3.073 12)","fill":"#515a70","stroke":"#515a70","stroke-width":".2"}},[_c('g',{attrs:{"id":"Ellipse_50","data-name":"Ellipse 50"}},[_c('circle',{attrs:{"cx":"1","cy":"1","r":"1","stroke":"none"}}),_c('circle',{attrs:{"cx":"1","cy":"1","r":"1.1","fill":"none"}})]),_c('g',{attrs:{"id":"Ellipse_51","data-name":"Ellipse 51","transform":"translate(5)"}},[_c('circle',{attrs:{"cx":"1","cy":"1","r":"1","stroke":"none"}}),_c('circle',{attrs:{"cx":"1","cy":"1","r":"1.1","fill":"none"}})]),_c('g',{attrs:{"id":"Ellipse_52","data-name":"Ellipse 52","transform":"translate(10)"}},[_c('circle',{attrs:{"cx":"1","cy":"1","r":"1","stroke":"none"}}),_c('circle',{attrs:{"cx":"1","cy":"1","r":"1.1","fill":"none"}})])])])])
          )
        }
      }
    